import React, { useState, useEffect } from 'react';
import api from '../../services/api';

const UsersPage = () => {
  const [users, setUsers] = useState([]);
  const [roles, setRoles] = useState([]);
  const [branches, setBranches] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [editingUser, setEditingUser] = useState(null);
  const [form, setForm] = useState({
    name: '', email: '', password: '', role_id: '', branch_id: '', phone: '', pin_code: '', is_active: true
  });

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const [usersRes, branchesRes] = await Promise.all([
        api.get('/users'),
        api.get('/branches'),
      ]);
      setUsers(usersRes.data.data || []);
      setBranches(branchesRes.data.data || []);
      // Extraer roles únicos de los usuarios
      const uniqueRoles = [...new Map((usersRes.data.data || []).map(u => [u.role?.id, u.role])).values()].filter(Boolean);
      setRoles(uniqueRoles);
    } catch (err) {
      console.error('Error:', err);
    }
  };

  const resetForm = () => {
    setForm({ name: '', email: '', password: '', role_id: '', branch_id: '', phone: '', pin_code: '', is_active: true });
    setEditingUser(null);
  };

  const createUser = async (e) => {
    e.preventDefault();
    try {
      await api.post('/users', form);
      setShowForm(false);
      resetForm();
      fetchData();
    } catch (err) {
      alert(err.response?.data?.message || 'Error al crear usuario');
    }
  };

  const updateUser = async (e) => {
    e.preventDefault();
    if (!editingUser) return;
    try {
      const updateData = { ...form };
      if (!updateData.password) delete updateData.password; // No enviar password vacío
      await api.put(`/users/${editingUser.id}`, updateData);
      setShowForm(false);
      resetForm();
      fetchData();
    } catch (err) {
      alert(err.response?.data?.message || 'Error al actualizar usuario');
    }
  };

  const toggleActive = async (user) => {
    try {
      await api.put(`/users/${user.id}`, { is_active: !user.is_active });
      fetchData();
    } catch (err) {
      alert('Error al cambiar estado');
    }
  };

  const startEdit = (user) => {
    setEditingUser(user);
    setForm({
      name: user.name || '',
      email: user.email || '',
      password: '',
      role_id: user.role_id || '',
      branch_id: user.branch_id || '',
      phone: user.phone || '',
      pin_code: user.pin_code || '',
      is_active: user.is_active !== false,
    });
    setShowForm(true);
  };

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
        <h1 style={{ color: '#e2e8f0', fontSize: 28 }}>👥 Usuarios</h1>
        <button onClick={() => { resetForm(); setShowForm(!showForm); }} className="btn btn-primary">
          {showForm ? 'Cancelar' : '+ Nuevo Usuario'}
        </button>
      </div>

      {showForm && (
        <div className="card animate-fade-in" style={{ marginBottom: 24 }}>
          <h3 style={{ color: '#e2e8f0', marginBottom: 16 }}>
            {editingUser ? '✏️ Editar Usuario' : 'Crear Usuario'}
          </h3>
          <form onSubmit={editingUser ? updateUser : createUser} style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 12 }}>
            <input type="text" placeholder="Nombre completo" className="input" value={form.name} onChange={e => setForm({...form, name: e.target.value})} required />
            <input type="email" placeholder="Correo electrónico" className="input" value={form.email} onChange={e => setForm({...form, email: e.target.value})} required />
            <input type="password" placeholder={editingUser ? 'Nueva contraseña (dejar vacío para no cambiar)' : 'Contraseña'} className="input" value={form.password} onChange={e => setForm({...form, password: e.target.value})} {...(!editingUser && { required: true })} />
            <input type="text" placeholder="Teléfono" className="input" value={form.phone} onChange={e => setForm({...form, phone: e.target.value})} />
            <select className="input" value={form.role_id} onChange={e => setForm({...form, role_id: e.target.value})} required>
              <option value="">Seleccionar rol...</option>
              {roles.map(r => <option key={r.id} value={r.id}>{r.name}</option>)}
            </select>
            <select className="input" value={form.branch_id} onChange={e => setForm({...form, branch_id: e.target.value})} required>
              <option value="">Seleccionar sucursal...</option>
              {branches.map(b => <option key={b.id} value={b.id}>{b.name}</option>)}
            </select>
            <input type="text" placeholder="PIN rápido (opcional)" className="input" value={form.pin_code} onChange={e => setForm({...form, pin_code: e.target.value})} />
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <input type="checkbox" id="user_is_active" checked={form.is_active} onChange={e => setForm({...form, is_active: e.target.checked})} style={{ width: 18, height: 18 }} />
              <label htmlFor="user_is_active" style={{ color: '#e2e8f0', fontSize: 14 }}>Usuario activo</label>
            </div>
            <button type="submit" className="btn btn-success" style={{ gridColumn: 'span 2' }}>
              {editingUser ? '💾 Guardar Cambios' : 'Crear Usuario'}
            </button>
          </form>
        </div>
      )}

      <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
        {users.map(user => (
          <div key={user.id} className="card" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
              <div style={{
                width: 40, height: 40, borderRadius: '50%',
                background: user.is_active ? 'linear-gradient(135deg, #38bdf8, #0ea5e9)' : '#334155',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                fontWeight: 'bold', color: user.is_active ? '#0f172a' : '#64748b',
              }}>
                {user.name?.charAt(0)?.toUpperCase()}
              </div>
              <div>
                <p style={{ color: '#e2e8f0', fontWeight: 600 }}>{user.name}</p>
                <p style={{ color: '#94a3b8', fontSize: 13 }}>{user.email} · {user.role?.name} · {user.branch?.name}</p>
              </div>
            </div>
            <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
              <button onClick={() => startEdit(user)} style={{
                padding: '6px 14px', borderRadius: 8, border: 'none',
                background: 'rgba(56, 189, 248, 0.1)', color: '#38bdf8',
                fontSize: 12, fontWeight: 600, cursor: 'pointer',
              }}>
                ✏️ Editar
              </button>
              <button onClick={() => toggleActive(user)} style={{
                padding: '6px 14px', borderRadius: 8, border: 'none',
                background: user.is_active ? 'rgba(239, 68, 68, 0.1)' : 'rgba(16, 185, 129, 0.1)',
                color: user.is_active ? '#ef4444' : '#10b981',
                fontSize: 12, fontWeight: 600, cursor: 'pointer',
              }}>
                {user.is_active ? 'Desactivar' : 'Activar'}
              </button>
              <span style={{
                padding: '4px 12px', borderRadius: 20, fontSize: 12, fontWeight: 600,
                background: user.is_active ? 'rgba(16, 185, 129, 0.1)' : 'rgba(239, 68, 68, 0.1)',
                color: user.is_active ? '#10b981' : '#ef4444',
              }}>
                {user.is_active ? 'Activo' : 'Inactivo'}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default UsersPage;
